<template>
  <div id="banner">
    <video
      autoplay
      loop
      muted
      poster="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Home+Page_Ge%CC%81ne%CC%81rique_couverture.jpg"
      class="home_video"
      @canplay="handleVideoPlay"
    >
      <source src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Home+Page_Ge%CC%81ne%CC%81rique.mov">
    </video>
    <div class="video-overlay"></div>
    <div class="banner-container">
      <div class="banner-text">
        <h1 class="banner-text--title"> {{ $t("Banner.header") }} </h1>
        <p class="banner-text--para raleway-reg-p17">{{ $t("Banner.subtitle") }}</p>
      </div>
      <div class="banner-search">
        <MainSearch></MainSearch>
      </div>
    </div>
    <div class="logo-see-more" @mouseover="animLogo" @click="scrollDown">
      <img src="../../images/fleche blanc.svg" v-set-alt>
    </div>
  </div>
</template>


<script>
import MainSearch from "../btns/MainSearch.vue";

export default {
  name: "banner",
  components: {
    MainSearch,
  },
  data() {
    return {
      search: "",
    };
  },
  methods: {
    handleVideoPlay() {
      const video = this.$el.querySelector(".home_video");
      video.classList.add("fade-in-video"); // Add fade-in class when video starts
    },
    animLogo(e) {
      e.currentTarget.animate(
        [
          { transform: "translateY(0px)" },
          { transform: "translateY(-10px)" },
          { transform: "translateY(0px)" },
        ],
        {
          duration: 800,
          easing: "ease-in-out",
          iterations: 2,
        }
      );
    },
    scrollDown() {
      const target = this.$el.nextElementSibling;
      if (!target) return;

      const navbar = document.querySelector("#navbar-main") || document.querySelector("#navbar");
      const headerOffset = navbar ? navbar.getBoundingClientRect().height : 0;
      const topMargin = 100;
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - topMargin;

      window.scrollTo({
        top: Math.max(top, 0),
        behavior: "smooth",
      });
    },
  },
};
</script>


<style lang="scss" scope='app/assets/stylesheets/components/banner'>
#banner {
  position: relative;
  height: 100vh;
  overflow: hidden;
}
.home_video {
  position: absolute;
  z-index: -1;
  min-width: 100%;
  min-height: 100%;
  height: auto;
  width: auto;
  background-size: cover;
  object-fit: cover;
  opacity: 0; // Initially hidden
  transition: opacity 1s ease-in-out; // Smooth fade-in transition
}

.home_video.fade-in-video {
  opacity: 1; // Video becomes visible when ready
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3); // Semi-transparent dark overlay
  z-index: 0;
  pointer-events: none;
}

.banner-container {
  position: relative;
  z-index: 1; // Ensure content appears above overlay

  @media screen and (max-height: 700px) {
    top: 10%;
  }
}

.banner-text {
  text-align: center;

  &--title {
    font-size: 40px;
    color: white;
  }

  &--para {
    font-size: 17px !important;
    color: white;
    text-transform: uppercase;
  }
}

.logo-see-more {
  position: absolute;
  bottom: 20px;
  cursor: pointer;
}

</style>
